module.exports = __webpack_public_path__ + "img/Result_Mid_0608_01.781c685b.png";